import React from "react";
import { PromptRequest, PromptTypeKey } from "../../../types/promptTypes";
import FieldContainer from "./FieldContainer";
import { usePromptStore } from "../../../store/promptStore";
import SelectDropdown from "../../dynamic/SelectDropdown";

type SelectFieldProps = {
  index: number;
};

const SelectField: React.FC<SelectFieldProps> = ({ index }) => {
  const prompts = usePromptStore((state) => state.prompts);
  const promptValues = usePromptStore((state) => state.promptValues);
  const setPromptValue = usePromptStore((state) => state.setPromptValue);

  const prompt = prompts[index] as PromptRequest<PromptTypeKey.SELECT>;
  const attributes = prompt.attributes;

  const selectedValues = promptValues[index]
    ? JSON.parse(promptValues[index])
    : [];

  const selectedValue = selectedValues.length > 0 ? selectedValues[0] : "";

  const dropdownOptions = attributes.options.map((option) => ({
    value: option,
    label: option,
  }));

  const handleChange = (value: string) => {
    setPromptValue(index, JSON.stringify([value]));
  };

  return (
    <FieldContainer field={prompt}>
      <SelectDropdown
        options={dropdownOptions}
        value={selectedValue}
        onChange={handleChange}
        placeholder="Select an option"
      />
    </FieldContainer>
  );
};

export default SelectField;
